import axios from "axios";

export default function EntrylocationByNetworkShowService(networkId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/entry_location/" + networkId + "/byNetwork",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
